import { render, staticRenderFns } from "./GeneGlobe.vue?vue&type=template&id=43a4bdcb&"
import script from "./GeneGlobe.vue?vue&type=script&lang=js&"
export * from "./GeneGlobe.vue?vue&type=script&lang=js&"
import style0 from "./GeneGlobe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports